import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class CustomPropertyClient extends BaseClient {
  buildEndpoint({projectId, workspaceId, customPropertyId, validate}) {
    let endpoint = appApiUrl(`custom_properties/`, {projectId, workspaceId});
    if (customPropertyId) {
      endpoint += `${customPropertyId}`;
    } else if (validate) {
      endpoint += `validate`;
    }

    return endpoint;
  }

  buildRequestBody({customProperty}) {
    return JSON.stringify(customProperty);
  }

  processResponse(response) {
    return response;
  }
}

export const customPropertyClient = new CustomPropertyClient();
